(function () {
  var timers = {};
  var DEBOUNCE = 350;

  function root() { return document.querySelector('[data-ig-cart]'); }
  function sectionId() { var r = root(); return r ? r.getAttribute('data-ig-cart-section') : null; }

  function setBusy(busy) {
    var r = root();
    if (r) r.classList.toggle('is-updating', !!busy);
  }

  function applyResponse(data, id) {
    document.querySelectorAll('[data-ig-cart-count]').forEach(function (el) {
      el.textContent = data.item_count;
    });
    var html = data.sections && data.sections[id];
    if (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-ig-cart]');
      var live = root();
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    }
    setBusy(false);
  }

  function changeLine(key, quantity) {
    var id = sectionId();
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: id ? [id] : [],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyResponse(data, id); })
      .catch(function () { window.location.reload(); });
  }

  function schedule(key, quantity) {
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      changeLine(key, quantity);
    }, DEBOUNCE);
  }

  // Delegated handlers survive the innerHTML swaps.
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-ig-cart-dec]');
    var inc = e.target.closest('[data-ig-cart-inc]');
    var rem = e.target.closest('[data-ig-cart-remove]');

    if (dec || inc) {
      var wrap = (dec || inc).closest('.ig-qty');
      var input = wrap && wrap.querySelector('[data-ig-cart-qty]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      v = inc ? v + 1 : Math.max(0, v - 1);
      input.value = v;                 // optimistic, instant
      schedule(input.dataset.key, v);  // debounced network call
      return;
    }

    if (rem) {
      e.preventDefault();
      changeLine(rem.dataset.key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-ig-cart-qty]');
    if (!input) return;
    var v = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = v;
    schedule(input.dataset.key, v);
  });
})();
